/**
 * Checks if browser has localStorage enabled
 * @returns boolean
 */
export function hasLocalStorage() {
  const test = 'test-local-storage'
  try {
    localStorage.setItem(test, test)
    localStorage.removeItem(test)
    return true
  } catch (e) {
    return false
  }
}

export const noop = () => {}

export const arrayToQuery = (arr?: string[]) =>
  arr ? arr.join(',') : undefined

export const onlyNumbers = (str: string): string => {
  const numbers = str.replace(/[^0-9]/g, '')
  return numbers
}

const fallbackCopyTextToClipboard = (text: string) => {
  const textArea = document.createElement('textarea')
  textArea.value = text

  // Avoid scrolling to bottom
  textArea.style.top = '0'
  textArea.style.left = '0'
  textArea.style.position = 'fixed'

  document.body.appendChild(textArea)
  textArea.focus()
  textArea.select()

  try {
    const success = document.execCommand('copy')
    if (!success) {
      throw Error(
        `execCommand did not return truthy, instead returned: ${success}`
      )
    }
  } catch (err) {
    console.error('Fallback: Unable to copy', err)
  }

  document.body.removeChild(textArea)
}

export const copyToClipboard = (text: string) => {
  if (!navigator.clipboard) {
    fallbackCopyTextToClipboard(text)
  } else {
    navigator.clipboard.writeText(text).catch((err) => {
      console.error('Async: Unable to copy: ', err)
    })
  }
}
